import { IonIcon } from '@ionic/react';
import React from 'react';
import styles from './Icon.module.css';

type IconSizes = 'small' | 'medium' | 'xmedium' | 'large' | 'xlLarge' | 'xxlLarge' | 'xxxlLarge' | 'xxxxlLarge';

type IconType = {
  color?: string;
  src: string;
  slot?: string;
  size?: IconSizes;
  className?: string;
  id?: string;
};

const Icon: React.FC<IconType> = (props) => {
  const { color = 'primary', size = 'small', className, ...delegated } = props;

  return <IonIcon {...delegated} color={color} className={`${styles[size]} ${className}`} />;
};

export default Icon;
